var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-col',{staticClass:"mx-auto",attrs:{"md":"8"}},[_c('div',{attrs:{"id":"chartsec"}},[_c('AreaChart',{attrs:{"array-data":_vm.summary}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }